import { render, staticRenderFns } from "./Resultat.vue?vue&type=template&id=265c07c4&scoped=true"
import script from "./Resultat.vue?vue&type=script&lang=js"
export * from "./Resultat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c07c4",
  null
  
)

export default component.exports